import BasicPlanResource from "./basicPlan.resource";

const basicPlanModule = angular
  .module("app.resources.basicPlan", [])
  .service("BasicPlan", BasicPlanResource);

export default basicPlanModule;



// WEBPACK FOOTER //
// ./src/resources/basicPlan/basicPlan.module.js